import { render, staticRenderFns } from "./Partner2.vue?vue&type=template&id=4eaffcab&scoped=true&"
import script from "./Partner2.vue?vue&type=script&lang=js&"
export * from "./Partner2.vue?vue&type=script&lang=js&"
import style0 from "./Partner2.vue?vue&type=style&index=0&id=4eaffcab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaffcab",
  null
  
)

export default component.exports